import { BookmarkState, RootState } from '@/store/storeStateInterfaces';
import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import Bookmark from '@/models/Bookmark';
import moment from 'moment';

const store: BookmarkState = {
    bookmarks: [],
    activeBookmark: undefined
};

const actions: ActionTree<BookmarkState, RootState> = {
    validateAllBookmarksAction: async ({ commit, state }): Promise<void> => {
        const timeToCheck = moment().subtract(process.env.VUE_APP_BOOKMARK_DELETION_HOURS, 'h');
        const filteredBookmarks = state.bookmarks.filter(bookmark => {
            return moment(bookmark.date).isAfter(timeToCheck);
        });
        commit('setBookmarks', filteredBookmarks);
    }
};

const mutations: MutationTree<BookmarkState> = {
    saveBookmark: (state: BookmarkState, bookmark: Bookmark) => {
        const bookmarkIndex = state.bookmarks.findIndex((savedBookmark) =>
            savedBookmark.publicationId === bookmark.publicationId);
        if (bookmarkIndex !== -1) {
            state.bookmarks[bookmarkIndex] = bookmark;
            state.activeBookmark = bookmark;
        } else {
            state.bookmarks.push(bookmark);
            state.activeBookmark = bookmark;
        }
    },
    removeBookmark: (state: BookmarkState, bookmark: Bookmark) => {
        state.bookmarks = state.bookmarks.filter((savedBookmark) =>
            savedBookmark.publicationId !== bookmark.publicationId);
        state.activeBookmark = undefined;
    },
    setActiveBookmark: (state: BookmarkState, bookmark: Bookmark) => {
        state.activeBookmark = bookmark;
    },
    setBookmarks: (state: BookmarkState, bookmarks: Bookmark[]) => { // Bookmarks are deleted after 24 hours
        state.bookmarks = bookmarks;
    }
};

const getters: GetterTree<BookmarkState, RootState> = {
    bookmarks: (state: BookmarkState) => state.bookmarks,
    activeBookmark: (state: BookmarkState) => state.activeBookmark,
    getBookmarkById: (state) => (publicationId: string) => {
        return state.bookmarks.find(bookmark => bookmark.publicationId === publicationId);
    }
};

const bookmarkStore: Module<BookmarkState, RootState> = {
    state: store,
    actions,
    mutations,
    getters
};

export default bookmarkStore;
